export default "__VITE_ASSET__BQUSQPhR__"